import classnames from 'classnames'
import { CSSProperties } from 'react'
import { RichText, RichTextProps } from '../../molecules/RichText'
import Button, { ButtonProps } from '../button'
import Image, { ImageProps } from '../image/Image'

import styles from './imageWithContent.module.scss'

export enum CONTENT_SIDE {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface ImageWithContentProps {
  sideImage: ImageProps | undefined
  style: CSSProperties
  icons?: ImageProps[]
  headingRichTextContent?: RichTextProps
  descriptionRichTextContent?: RichTextProps
  type?: CONTENT_SIDE
  className?: string
  buttonPropsList?: ButtonProps[]
}

export const ImageWithContent = ({ className = '', type = CONTENT_SIDE.LEFT, ...props }: ImageWithContentProps) => {
  const mainWraperClasses = classnames(styles.mainDivWrap, className)
  const wraperClasses = classnames(styles.imageWithContentWrap, styles[`content__${type}`])

  const contentDivClasses = classnames(styles.contentDiv, 'colour--black font-line-height--3')

  return (
    <div style={props.style} className={mainWraperClasses}>
      <div className={wraperClasses}>
        <div className={contentDivClasses}>
          {props.headingRichTextContent && (
            <RichText className={classnames(styles.image_with_content_title)} {...props.headingRichTextContent} />
          )}
          {props.descriptionRichTextContent && (
            <RichText className={classnames(styles.image_with_content_text)} {...props.descriptionRichTextContent} />
          )}
          {!!props.icons?.length && (
            <div className={styles.sideIconsWrap}>
              {props.icons.map((image: ImageProps, index: number) => {
                return (
                  <Image
                    {...image}
                    style={{
                      maxWidth: image.width,
                    }}
                    className={classnames(styles.sideIcon, image.className)}
                    key={index}
                  />
                )
              })}
            </div>
          )}
          {(props.buttonPropsList || []).map((buttonProps: ButtonProps) => (
            <Button
              {...buttonProps}
              key={buttonProps.id}
              className={classnames(styles.actionButton, buttonProps.className)}
            />
          ))}
        </div>
        <Image {...props.sideImage} className={styles.slideImage} />
      </div>
    </div>
  )
}

export default ImageWithContent
